import React, { useState } from "react";
import { PlusIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/landing";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-137" data-mp="2z2yxcnh85mzj">
      <div className="mx-auto max-w-3xl" data-id="element-138" data-mp="2z3h2yaps1dk4">
        <SectionHeading title="Frequently asked questions" data-id="element-139" data-mp="3mt32iza29usn" />
        <ul className="mt-10 space-y-3" data-id="element-140" data-mp="3mtl3uabkyz7f">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="rounded-2xl border border-brand-100 bg-cream" data-id="element-141" data-mp="3d39ntpemgzk6" data-mpi={i}>
                <h3 data-id="element-142" data-mp="3i2357sx15apm">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-base font-bold text-ink sm:text-lg" data-id="element-143" data-mp="3i1kx9z10981v">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-brand-600 transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-144" data-mp="1vs5ftxocolc8" />
                  </button>
                </h3>
                <div id={`faq-${i}`} className={`grid transition-[grid-template-rows] duration-200 ease-out ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`} data-id="element-145" data-mp="2jh7wb2790855">
                  <div className="overflow-hidden" data-id="element-146" data-mp="2tfxhp4ycsaq5">
                    <p className="px-5 pb-5 leading-relaxed text-muted" data-id="element-147" data-mp="2temb6xdiwovc">{f.a}</p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
        <CTAButton className="mt-10" label="My questions are answered — I'm in" data-id="element-148" data-mp="z25zhh1ykij3" />
      </div>
    </section>;
}